@let corporateDesign = corporateDesignService.corporateDesign;
@let footer = footerStore.footer();
@let footerBackground = corporateDesign().colorAdmixtures.dark_surface_01;
@let isDarkMode = corporateDesignService.isDarkModeActive();
@let isLoading =
  corporateDesignService.isCorporateDesignLoading() || footerStore.isLoading();
@if (isLoading) {
  <div class="pt-32">
    <aw-loading-animation
      [entityType]="EEntityType.footer"
      [relationType]="RelationType.loading"></aw-loading-animation>
  </div>
}
@if (corporateDesign() && footer && !isLoading) {
  <div
    class="flex w-full justify-center"
    [attr.data-testid]="'footer'"
    [style.color]="
      isDarkMode
        ? footer.appearance?.fontColorDark ||
          corporateDesignService.darkFontColor(
            corporateDesign().primaryFontColor
          )
        : footer.appearance?.fontColor || corporateDesign().primaryFontColor
    "
    [ngStyle]="{
      backgroundColor: isDarkMode
        ? footer.appearance?.backgroundColorDark || footerBackground
        : footer.appearance?.backgroundColor || footer.backgroundColor,
      backgroundImage: backgroundImage(footer),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    }">
    <div class="w-full max-w-250">
      <div
        class="bottom-0 flex min-h-10 w-full max-w-full flex-wrap items-start justify-start gap-2 overflow-hidden p-2 text-left">
        <!-- Link Block -->
        @if (isFooterBlockVisible(footer, 'linkArea')) {
          <aw-footer-block
            [children]="linkBlockChildren"
            [style.order]="footerBlockOrder(footer, 'linkArea')"
            name="link"
            [showHeadline]="isHeadlineVisible(footer, 'linkArea')"
            headline="{{ footer.linkArea.headlines | language }}"
            [headlineSize]="corporateDesign().fontSizeTitle">
            <ng-template #linkBlockChildren>
              @for (link of footer.linkArea.links; track link.id) {
                @let url =
                  link.texts | filterTexts: RelationType.url | language;
                @if (url) {
                  <a
                    [attr.data-testid]="'link-' + link.id"
                    [style.font-size]="
                      corporateDesign().fontSizeText | toFontSize
                    "
                    class="hover:text-primary-main block hover:underline"
                    [href]="url"
                    [id]="link.id">
                    {{ link.texts | filterTexts: RelationType.text | language }}
                  </a>
                } @else {
                  <span
                    [style.font-size]="
                      corporateDesign().fontSizeText | toFontSize
                    "
                    >{{
                      link.texts | filterTexts: RelationType.text | language
                    }}</span
                  >
                }
              }
            </ng-template>
          </aw-footer-block>
        }

        @for (block of footer.blocks ?? []; track block.id) {
          @if (
            block.isActive && block.id && isFooterBlockVisible(footer, block.id)
          ) {
            <aw-footer-block
              [block]="block"
              [paymentProviders]="footer.layout?.paymentProviders?.[block.id]"
              [style.order]="
                footerBlockOrder(footer, block.id)
              "></aw-footer-block>
          }
        }

        @if (hasRowBreak(footer)) {
          <div
            class="w-full"
            [style.order]="footerBlockOrder(footer, 'ROW_BREAK')"></div>
        }
      </div>
    </div>
  </div>
}
